import {EventEmitter, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Observable} from 'rxjs/Observable';

export abstract class StepComponentAbstract {

  @Output() saveForm = new EventEmitter();

  data: any;
  stepForm: FormGroup;

  abstract loadData(userId): void;

  abstract onSave(): Observable<any>;

  isSaveInProgress: boolean = false;

  abstract updateChanges(): Observable<any>[];
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/flow/step.component.ts